module.exports = __webpack_public_path__ + "img/right.dd62bf7c.svg";